import styled, { css } from 'styled-components';

export const StyledContentTutorial = styled.div`
  padding: 20px 12px;

  h1 {
    margin: 0 8px 20px;
    color: ${({ theme }) => theme.primary};
    text-align: center;
  }

  .list {
    list-style: none;
    margin: 0;
    padding: 0 4px;
    overflow-y: auto;
    height: calc(100vh - 145px);

    /* Scrollbar */
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.containerHover} transparent;
  }

  .item-list {
    position: relative;

    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 10px 12px;
    margin: 4px 0;

    border-radius: 8px;

    color: ${({ theme }) => theme.text};
    font-size: 0.9rem;

    transition:
      background-color 0.2s ease,
      color 0.2s ease,
      transform 0.2s ease;

    span {
      font-weight: 500;
      font-size: 0.9rem;
      padding-left: 8px;
    }

    &:hover {
      background-color: ${({ theme }) => theme.containerHover};
      cursor: pointer;
      transform: translateX(2px);
    }

    &.active {
      background-color: ${({ theme }) => theme.primary}15;
      color: ${({ theme }) => theme.primary};
      font-weight: 600;

      &::before {
        content: "";
        position: absolute;
        left: -4px;
        top: 25%;
        width: 3px;
        height: 50%;
        border-radius: 4px;
        background-color: ${({ theme }) => theme.primary};
      }
    }
  }

  .item-content span {
    font-weight: 500;
    font-size: 0.9rem;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .item-actions {
    display: flex;
    align-items: center;
    gap: 4px;

    flex-shrink: 0;
  }

  .tutorial-group {
    margin-bottom: 6px;
  }

  .group-header {
    width: 100%;

    display: flex;
    align-items: center;

    padding: 9px 10px;
    margin: 2px 0;

    border: none;
    border-radius: 8px;

    background: transparent;
    color: ${({ theme }) => theme.text};

    font-size: 0.8rem;
    font-weight: 600;
    text-align: left;

    cursor: pointer;

    transition:
      background-color 0.2s ease,
      color 0.2s ease;
  }

  .group-header:hover {
    background-color: ${({ theme }) => theme.containerHover};
  }

  .group-title {
    flex: 1;
    color: ${({ theme }) => theme.color};
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .group-count {
    display: flex;
    align-items: center;
    justify-content: center;

    min-width: 22px;
    height: 20px;

    padding: 0 6px;

    border-radius: 10px;
    color: ${({ theme }) => theme.color};

    background-color: ${({ theme }) => theme.containerHover};

    font-size: 0.7rem;
    font-weight: 600;

    &:hover {
      background-color: ${({ theme }) => theme.grey};
    }
  }

  .group-tutorials {
    list-style: none;

    margin: 2px 0 8px;
    padding: 0 0 0 8px;
  }
`;

export const IconFlipWrapper = styled.span<{flip: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 20px;
  margin-right: 4px;

  font-size: 0.8rem;

  & svg {
    width: 25px;
    height: 25px;
    fill: ${({ theme }) => theme.primary};
  }
  transition: all 0.2s;
  transform: rotate(-90deg);
  ${({ flip }) => flip && css`
    transform: rotate(0deg);
  `}
`;

export const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 5px;
  & svg {
    width: 20px;
    height: 20px;
    fill: ${({ theme }) => theme.grey}
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${({ theme }) => theme.backgroundOdd};
  border-radius: 10px;
  box-shadow: 0px 4px 4px ${({ theme }) => theme.shadow};
  padding: .2rem .6rem;
  margin: 0 16px;
  & .inputTxt {
    padding-top: 5px;
  }
`;

export const ToolbarTutorial = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SeparatorLine = styled.hr`
  margin: 1.5rem auto 1rem auto;
  width: 80%;
  border: 0.8px solid #ddd;
`;

export const NoTutorials = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0.6rem;
  font-weight: bold;
`;
